/**
 * Modal de reconciliación de ítems huérfanos
 */

import React from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { CONFIDENCE_LEVELS } from '../utils/constants';

const ReconciliationModal = ({
  show,
  onHide,
  matches,
  orphanItems,
  selectedMatches,
  onMatchSelection,
  onSelectAll,
  onExecute,
  loading
}) => {
  if (!show) return null;

  const hasSelectedMatches = Object.values(selectedMatches).some(Boolean);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="reconciliation-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FaIcons.FaLink className="me-2" />
          Reconciliación de Ítems Huérfanos
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center py-4">
            <FaIcons.FaSpinner className="fa-spin" size={30} />
            <p className="mt-3">Procesando reconciliación...</p>
          </div>
        ) : matches && matches.matches ? (
          <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1">
                  Matches encontrados: {matches.summary?.matches_found || 0}
                </h6>
                <small className="text-muted">
                  Sin matches: {matches.summary?.no_matches || 0}
                </small>
              </div>
              <div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => onSelectAll(true)}
                  className="me-2"
                >
                  Seleccionar Todos
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => onSelectAll(false)}
                >
                  Deseleccionar Todos
                </Button>
              </div>
            </div>

            <div className="table-responsive">
              <Table striped bordered hover size="sm">
                <thead className="table-primary">
                  <tr>
                    <th style={{ width: '50px' }}>Sel.</th>
                    <th>Ítem Original</th>
                    <th>Ítem Limpio</th>
                    <th>Cliente</th>
                    <th>Confianza</th>
                    <th>Guía Sugerida</th>
                    <th>Precio</th>
                  </tr>
                </thead>
                <tbody>
                  {matches.matches.map((match, index) => {
                    const isSelected = selectedMatches[match.item_id] || false;
                    const orphanItem = orphanItems.find(
                      item => item.item_id === match.item_id
                    );

                    return (
                      <tr key={match.item_id || index}>
                        <td className="text-center">
                          {match.guia_match ? (
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) =>
                                onMatchSelection(match.item_id, e.target.checked)
                              }
                            />
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td className="fw-bold">
                          {match.item_original || match.item_cleaned}
                        </td>
                        <td>{match.item_cleaned}</td>
                        <td>{orphanItem?.cliente?.cliente || 'N/A'}</td>
                        <td>
                          <Badge
                            bg={
                              CONFIDENCE_LEVELS[match.confidence]?.color ||
                              'secondary'
                            }
                          >
                            {CONFIDENCE_LEVELS[match.confidence]?.label ||
                              'Desconocida'}
                          </Badge>
                        </td>
                        <td>
                          {match.guia_match ? (
                            <div>
                              <strong>{match.guia_match.guia}</strong>
                              <br />
                              <small className="text-muted">
                                ID: {match.guia_match.guia_id}
                              </small>
                            </div>
                          ) : (
                            <span className="text-muted">Sin match encontrado</span>
                          )}
                        </td>
                        <td className="text-end">
                          {match.guia_match ? (
                            `$${
                              match.guia_match.precio?.toLocaleString('es-CL') ||
                              'N/A'
                            }`
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <div className="mt-3 p-3 bg-light rounded">
              <h6>Resumen de selección:</h6>
              <p className="mb-1">
                Ítems seleccionados:{' '}
                {Object.values(selectedMatches).filter(Boolean).length}
              </p>
              <p className="mb-0 text-muted">
                Estos ítems serán reconciliados con sus guías correspondientes.
              </p>
            </div>
          </div>
        ) : (
          <div className="text-center py-4">
            <FaIcons.FaExclamationTriangle
              size={40}
              className="text-warning mb-3"
            />
            <p className="text-muted">No se encontraron datos de matches</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={onExecute}
          disabled={loading || !hasSelectedMatches}
        >
          {loading ? (
            <>
              <FaIcons.FaSpinner className="fa-spin me-2" />
              Ejecutando...
            </>
          ) : (
            <>
              <FaIcons.FaCheck className="me-2" />
              Ejecutar Reconciliación (
              {Object.values(selectedMatches).filter(Boolean).length})
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReconciliationModal;
